import { IconChessBishop, IconChessKing, IconUser } from "@tabler/icons-react"
import type { TUser } from "@/types"

const icons: Record<TUser["role"], any> = {
  user: IconUser,
  manager: IconChessBishop,
  admin: IconChessKing,
  owner: IconChessKing,
}

export function RoleIcon({ role }: { role: TUser["role"] | null }) {
  if (!role) return null
  const Icon = icons[role]
  return Icon ? <Icon size={16} /> : null
}
